import React, { Component } from 'react';
import { Input, FormFeedback } from 'reactstrap';
import Dom from '../../utils/Dom';
import ReCAPTCHA from 'react-google-recaptcha';

// this component allows for catpcha validation using bootstrap form validation by returning a hidden input which is only validated
// when a valid captcha value in generated, which is only occurs after successful captcha submission. See OutOfStockEmail.js
// for usage

class EirRecaptcha extends Component {
  constructor(props) {
    super(props);

    this._reCaptchaRef = React.createRef();

    this.state = {
      value: '',
      load: false
    };
  }

  componentDidMount() {
      this.setState({ load: true });
  }

  handleChange = value => {
      this.setState({ value : value });
  };

  render() {
    return (
      <div className="mt-4 captcha-container d-flex flex-column justify-content-start align-items-center">
        {this.state.load && (
        <ReCAPTCHA
            ref={this._reCaptchaRef}
            sitekey="6LcOxAwTAAAAAF5__VsIqOYfJQVFc1dNQ6aACQqn"
            onChange={this.handleChange}
          />)}
        <Input
          className="recaptcha-hidden-input"
          type="text"
          value={this.state.value}
          minLength="5"
          required
          // id="recaptcha"          
          // tabIndex={-1}
          // aria-hidden="true"
          disabled={!this.state.value}
        />
        <FormFeedback className="recaptcha-feedback">
          Please complete the captcha
        </FormFeedback>
      </div>
    );
  }
}

export default EirRecaptcha;
